import React, { useEffect, useMemo, useRef } from "react";
import $ from "jquery";
import blueimp from "blueimp";
import highlight from "libraries/highlight";

interface Props {
  agentResult: any; // Backbone.Model (AgentResult)
}

export default function DatalakeGalleryCarousel({ agentResult }: Props) {
  const internalIdRef = useRef(
    `blueimp-gallery-carousel-${Math.random().toString(36).slice(2, 9)}`
  );
  const galleryId = internalIdRef.current;
  const images = useMemo(() => {
    const attachments = agentResult.clipAttachments ? agentResult.clipAttachments() : [];
    return attachments.filter((attachment: any) => attachment.file_type === "image");
  }, [agentResult]);

  const showGallery = images.length > 0;

  useEffect(() => {
    if (!showGallery) {return;}

    const data = images.map((img: any) => {
      let caption;
      let title;

      if (img.caption) {
        caption = highlight(img.caption);
        title = caption.replace(/<\/?[^>]+(>|$)/g, "");
      }

      return {
        title,
        caption,
        href: img.url,
        thumbnail: img.url,
      };
    });

    const startIndex = data.findIndex((d) => /clip-detail__highlight/.test(d.caption || ""));
    const normalizedIndex = startIndex >= 0 ? startIndex : 0;
    const multipleImages = images.length > 1;
    const options: any = {
      container: `#${galleryId}`,
      index: normalizedIndex,
      carousel: true,
      startSlideshow: false,
      enableKeyboardNavigation: multipleImages,
    };

    if (multipleImages) {
      $(`#${galleryId}`).removeClass("single");
    } else {
      options.emulateTouchEvents = false;
    }

    const gallery = blueimp(data, options);
    gallery.onclick = () => { gallery.next(); };

    return () => {
      if (!gallery) {return;}
      if (gallery.eventListeners && typeof gallery.destroyEventListeners === "function") {
        gallery.destroyEventListeners();
      }
      if (typeof gallery.close === "function") {
        gallery.close();
      }
    };
  }, [galleryId, images, showGallery]);

  if (!showGallery) {return null;}

  return (
    <div id={galleryId} className="blueimp-gallery blueimp-gallery-carousel blueimp-gallery-controls single">
      <div className="slides"></div>
      <div className="slides-background"></div>
      <span className="counter"></span>
      <span className="caption"></span>
      <a className="download" target="_new">
        <i className="icon-download"></i>
      </a>

      <a className="prev">
        <i className="prevIcon fa fa-caret-left"></i>
      </a>
      <a className="next">
        <i className="nextIcon fa fa-caret-right"></i>
      </a>
   </div>
  );
}
